import { useEffect, useState } from "react";
import "./DownloadMultiplePopup.scss";
import OrganizationsPickerTable from "../utils/OrganizationsPickerTable";
import {
	OrganizationsPickerContextProvider,
	useOrganizationPicker,
} from "../../context/organizations-picker.context";
import WizardModal, {
	WizardBody,
	WizardFooter,
	WizardHeader,
	WizardStepContent,
} from "./wizard/WizardModal";
import PlanDownloadContentPicker from "../plan-download/PlanDownloadContentPicker";

export default function DownloadMultipleModal({
	organizations = [],
	organizationTypes = [],
	...props
}) {
	return (
		<OrganizationsPickerContextProvider organizations={organizations} types={organizationTypes}>
			<DownloadMultipleModalContent {...props} />
		</OrganizationsPickerContextProvider>
	);
}

function DownloadMultipleModalContent({
	open,
	setOpen,
	template,
	loadingData,
	statuses,
	templateId,
}) {
	const { setFilteredList, organizations, setFilterType, selectedEntity, setSelectedEntity } =
		useOrganizationPicker();

	const [isCloseDisabled, setIsCloseDisabled] = useState(false);

	useEffect(() => {
		if (open) {
			setSelectedEntity([]);
			setFilteredList(organizations);
			setFilterType([]);
		}
	}, [open]);

	return (
		<WizardModal
			open={open}
			setOpen={setOpen}
			disableClose={isCloseDisabled}
			className="plan_download_popup"
			stepClassName={{ 1: "corps_wizard" }}
		>
			{/* Step 1 */}
			<WizardStepContent stepIndex={1}>
				<WizardHeader
					title="Genera documento massivo"
					description="Seleziona gli enti di destinazione"
				/>

				<WizardBody stepIndex={1}>
					<OrganizationsPickerTable loadingData={loadingData} />
				</WizardBody>

				<WizardFooter disableNext={selectedEntity.length === 0} />
			</WizardStepContent>

			{/* Step 2/3 */}
			<PlanDownloadContentPicker
				stepConfiguration={{
					status: {
						title: "Genera documento massivo",
					},
					template: {
						title: "Genera documento massivo",
						label_cta: "Genera documenti",
					},
					approvals: {
						description:
							"Durante il download massivo, viene inclusa automaticamente l’ultima adozione effettuata.",
					},
				}}
				open={open}
				template={template}
				onStart={() => setIsCloseDisabled(true)}
				onFinish={() => {
					setIsCloseDisabled(false);
					setOpen(false);
				}}
				statuses={statuses}
				templateId={templateId}
				selectedOrganizationsPlans={
					selectedEntity?.map((item) => ({
						organization_id: item.id,
						organization_plan_id: item?.organization_plans?.[0]?.id || 0,
					})) || []
				}
				stepStart={2}
			/>
		</WizardModal>
	);
}
